module.exports = __webpack_public_path__ + "static/beach-poster-2871a257c0b1ea3889e07eba058734f2.jpg";